// extracted by mini-css-extract-plugin
export default {"container":"mzSAzy","container2":"xFZ0RB","languages":"f8OBFj","language":"PFR1db","link":"omMjoU","selected":"d8Np4u","closeButton":"m61YqL"};